import type { CelestialBody } from '../types'

// The inner worlds: too close to Pyrithos to be kind.
export const kethux: CelestialBody = {
  id: 'kethux',
  name: 'Kethux',
  type: 'molten',
  tagline: 'A simple molten planet with no real purpose.',
  lore: `**Kethux** is a simple molten planet with no real purpose, as far as anyone knows. It just sits there, far too close to Pyrithos, its surface permanently molten. Nothing survives on it and there is not much to do with it. A clean, dramatic way out for anyone who decides they are done, if that is the ending you want.`,
  render: { color: '#ff6a2b', size: 11, orbitRadius: 95, orbitPeriod: 22, phase: 0.4 },
}

export const golgaron: CelestialBody = {
  id: 'golgaron',
  name: 'Golgaron',
  type: 'rocky',
  tagline: 'A toxic rock whose ore keeps the whole system flying.',
  lore: `**Golgaron** is a rocky planet valued mostly for its minerals and ore. The ground itself is toxic, so there are no long term stays, only rotating mining crews who get in, extract, and get out before the exposure catches up with them. The resources pulled from Golgaron are the backbone of building and maintaining ships and stations across the system, hull plating, structural metals, components, etc. Everyone needs what comes out of Golgaron, which makes the mining a target for raiders.`,
  render: { color: '#9c8164', size: 9, orbitRadius: 150, orbitPeriod: 38, phase: 1.2 },
}
